// extracted by mini-css-extract-plugin
export default {"header":"HeaderMegaMenu_header__jW4DG","link":"HeaderMegaMenu_link__vCX-H","subLink":"HeaderMegaMenu_subLink__A3bWY","dropdownFooter":"HeaderMegaMenu_dropdownFooter__zPZAh"};